import { DELTA_T } from '../waveform';
import type { WaveformApi } from '../waveform';
import type { CustomWaveform } from '~/models/studio';

export const wfCustom: WaveformApi<CustomWaveform> = {
  samples: (wf) => [...wf.samples],
  sampleAt: (wf, t) =>
    wf.samples[Math.min(Math.floor(t), wf.samples.length - 1)],
  area: (wf) => wf.samples.reduce((s, v) => s + v * DELTA_T, 0),
  bounds: (wf) => ({
    min: Math.min(...wf.samples),
    max: Math.max(...wf.samples)
  }),
  points: (wf, o) => wf.samples.map((v, i) => ({ x: i + o, y: v })),
  duration: (wf) => wf.samples.length
};
